<template>
    <div>
        <CCol sm="12" class="bg-FAFAFA">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <br /> <br />
                <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12">
                            <h3 class="custom-40px-500 text-center mt-0">Billing</h3>
                            <p class="custom-18px-400 text-center m-2">The AI Interviewrr Billing</p>
                        </CCol>
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="10">
                                    <CInput type="text" placeholder="Search Input" v-model="searchQuery" @keyup.enter="filterList" />
                                </CCol>
                                <CCol sm="2">
                                    <CSelect>
                                        <CSelect label="Sort By" :options="['Sort By',2,3,4,5,6,7,8,9,10,11,12]" />
                                    </CSelect>
                                </CCol>
    
                            </CRow>
                            <template v-if="Busy == true">
                            <div class="container text-center">
                              <pulse-loader
                                :loading="loading"
                                :color="color"
                                :size="size"
                              ></pulse-loader>
                            </div>
</template>
                    <table class="table table-responsive-sm table-hover table-outline mb-0 mt-3 ml-15 mr-15" style="border:none">
                        <thead class="bg-f7f7f7 b-20">
                            <th> <label class="custom-12px-700">ID</label></th>
                            <th> <label class="custom-12px-700">Date</label></th>
                            <th> <label class="custom-12px-700">Name</label></th>
                            <th><label class="custom-12px-700">Email</label></th>
                            <th> <label class="custom-12px-700">Mobile Number</label></th>
                            <th><label class="custom-12px-700">Total(USD)</label></th>
                            <th><label class="custom-12px-700">Status</label></th>
                        </thead>

                        <tbody>
                            <tr v-for="(item,index) in filteredList" v-bind:key="item.id">
                                <td>
                                    {{ index+1 }}
                                    </td>
                                    <td>{{ item.date | moment("DD-MM-YYYY") }}</td>
                                    <td>



                                   <label class="custom-12px-500 ml-2">{{ item.name }}</label> 
                                </td>
                                <td>
                                    <label class="custom-12px-700">{{ item.email }}</label>
                                </td>
                                <td>
                                    <label class="custom-12px-700">{{ item.mobile }}</label>
                                </td>
                                <td>
                                    <label class="custom-12px-700">{{ item.amountUsd }}</label>
                                </td>
                                <td>
                                    <label class="custom-badge-success font-color-61CE5F">Paid</label>
                                </td>
                            </tr>
                        
                        </tbody>
                    </table>
                </CCol>

            </CRow>

           
        </CCard>
<br /><br /><br />
    </CCol>

</CCol>

    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        PulseLoader
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            isPopupVisible2: false,
            list: [],
            user: {},
            isPopupVisible3: false,
            searchQuery: '',
            Busy: false

        };
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser(); // Fetch the user details first
                await this.GetListPayment();

            } else {
                this.GoToLogin();
            }
        } catch (error) {
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {
        filteredList() {
            const query = this.searchQuery.toLowerCase().trim();

            return this.list.filter(item => {
                const matchesQuery = query ? item.name.toLowerCase().includes(query) : true;

                return matchesQuery;
            });
        }
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListPayment() {
            try {
                this.Busy = true;
                const response = await this.$API.get(this.$GetListSuccessPackageSubscription);
                if (response.status === 200) {
                    this.Busy = false;
                    this.list = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },


    }

};
</script>

